import React, { useContext } from 'react';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { Card } from '@uhg-abyss/web/ui/Card';
import { cellValueHighLight } from '@src/utils/tableUtils';

import { Table, FILL_WIDTH_COLUMNS_CSS } from '@src/common/Table';
import { useLazyGetReportsQuery } from '@src/store/services/cdb/onlineServices';
import { useLazyGetGPSReportsQuery } from '@src/store/services/gps/onlineServices';
import { FileContext } from '@src/routes/Routes';

export const PCPRollover = () => {
  const router = useRouter();
  const { service } = router.getRouteParams();

  const { fileData } = useContext<any>(FileContext);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Employee ID',
        accessor: 'employeeId',
        canToggleVisibilty: false,
        isHiddenByDefault: false,
        minWidth: 50,
        width: 50,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Name',
        accessor: 'name',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 65,
        width: 65,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Birth Date',
        accessor: 'birthDate',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 50,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
        width: 50,
      },

      {
        Header: 'Rel',
        accessor: 'rel',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 20,
        width: 20,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Provider Id',
        accessor: 'providerId',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 55,
        width: 55,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Location Sequence No.',
        accessor: 'locationSequenceNo',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
        minWidth: 40,
        width: 40,
      },
      {
        Header: 'Status',
        accessor: 'pcpStatus',
        minWidth: 65,
        width: 65,
        canToggleVisibilty: true,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
        isHiddenByDefault: false,
      },
      {
        Header: 'Rollover -CDB Error Code Detail',
        accessor: 'rolloverCDBErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 60,
        width: 60,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Rollover -CES Error Code Detail',
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
        accessor: 'rolloverCESErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 60,
        width: 60,
      },
      {
        Header: 'Rollover -NDB Error Code Detail',
        accessor: 'rolloverNDBErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 60,
        width: 60,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Rollover - UP2S Error Code Detail',
        accessor: 'rolloverUP2SErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 60,
        width: 60,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Randomization - CDB Error Code Detail',
        accessor: 'rndmznCDBErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 60,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
        width: 60,
      },
      {
        Header: 'Randomization - CES Error Code Detail',
        accessor: 'rndmznCESErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 60,
        width: 60,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Randomization - NDB Error Code Detail',
        accessor: 'rndmznNDBErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 60,
        width: 60,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Randomization - UP2S Error Code Detail',
        accessor: 'rndmznUP2SErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 90,
        width: 90,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
    ],
    []
  );

  return (
    <Card>
      <div
        style={{
          backgroundColor:
            'var(--abyss-colors-web-semantic-color-surface-container-primary)',
          color:
            'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
          fontSize: '18px',
          padding: '24px',
          borderTopLeftRadius: '3px',
          borderTopRightRadius: '3px',
          fontWeight: 'bold',
        }}
      >
        PCPRollover Reports
      </div>
      <div style={{ padding: '16px' }}>
        <Table
          columns={columns}
          dataKey="pcprollover-reports"
          fetch={
            service === 'gps'
              ? useLazyGetGPSReportsQuery
              : useLazyGetReportsQuery
          }
          requestParams={{
            ...router.getRouteParams(),
            ...fileData,
            allDate: 'false',
          }}
          showGlobalFilter={false}
          tableCss={FILL_WIDTH_COLUMNS_CSS}
        />
      </div>
    </Card>
  );
};
